/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FamilyHistoryResponseDto
 */
export interface FamilyHistoryResponseDto {
    /**
     * Identity of the Family member
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    familyMemberId: string;
    /**
     * Identity of the Patient
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    patientId: string;
    /**
     * Cancer type
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    cancer?: string;
    /**
     * Diabetes details
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    diabetes?: string;
    /**
     * Autoimmune disease details
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    autoimmuneDisease?: string;
    /**
     * Heart disease details
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    heartDisease?: string;
    /**
     * Stroke details
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    stroke?: string;
    /**
     * Other disease
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    other?: string;
    /**
     * Additional information
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    additionalInformation?: string;
    /**
     * Last updated timestamp
     * @type {string}
     * @memberof FamilyHistoryResponseDto
     */
    lastUpdated: string;
}

/**
 * Check if a given object implements the FamilyHistoryResponseDto interface.
 */
export function instanceOfFamilyHistoryResponseDto(value: object): value is FamilyHistoryResponseDto {
    if (!('familyMemberId' in value) || value['familyMemberId'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    return true;
}

export function FamilyHistoryResponseDtoFromJSON(json: any): FamilyHistoryResponseDto {
    return FamilyHistoryResponseDtoFromJSONTyped(json, false);
}

export function FamilyHistoryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyHistoryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'familyMemberId': json['familyMemberId'],
        'patientId': json['patientId'],
        'cancer': json['cancer'] == null ? undefined : json['cancer'],
        'diabetes': json['diabetes'] == null ? undefined : json['diabetes'],
        'autoimmuneDisease': json['autoimmuneDisease'] == null ? undefined : json['autoimmuneDisease'],
        'heartDisease': json['heartDisease'] == null ? undefined : json['heartDisease'],
        'stroke': json['stroke'] == null ? undefined : json['stroke'],
        'other': json['other'] == null ? undefined : json['other'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
        'lastUpdated': json['lastUpdated'],
    };
}

export function FamilyHistoryResponseDtoToJSON(json: any): FamilyHistoryResponseDto {
    return FamilyHistoryResponseDtoToJSONTyped(json, false);
}

export function FamilyHistoryResponseDtoToJSONTyped(value?: FamilyHistoryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'familyMemberId': value['familyMemberId'],
        'patientId': value['patientId'],
        'cancer': value['cancer'],
        'diabetes': value['diabetes'],
        'autoimmuneDisease': value['autoimmuneDisease'],
        'heartDisease': value['heartDisease'],
        'stroke': value['stroke'],
        'other': value['other'],
        'additionalInformation': value['additionalInformation'],
        'lastUpdated': value['lastUpdated'],
    };
}

